// removed by extract-text-webpack-plugin
module.exports = {"info":"src-components-address-home----address-home-module---info---36ePL","list":"src-components-address-home----address-home-module---list---1mXUt","item":"src-components-address-home----address-home-module---item---24sxd","desktopTel":"src-components-address-home----address-home-module---desktopTel---2lnQP","mobileTel":"src-components-address-home----address-home-module---mobileTel---39cH1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/address-home/address-home.module.css
// module id = 232
// module chunks = 35783957827783